// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".App__title {\n  font-size: 28px;\n}\n", "",{"version":3,"sources":["/home/viniazvd/vue-coe-calendar/examples/App.vue"],"names":[],"mappings":"AA2CE;EACE,eAAe;AAAA","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.App {\n  &__title {\n    font-size: 28px;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
